import { i18n } from '@fishx/i18n';
import { message } from '@whalecloud/fdx';
import { getRequestData, emptyObj } from '@/utils';
import { createAccount } from '@/pages/NewConnection/services';

export default {
  namespace: 'billingAccountInfo',
  state: {
    certTypeList: [],
    stateAddrOpts: [],
    districtOpts: [],
    mainLocalityOpts: [],
    subLocalityOpts: [],
    attrObj: {}, // account_type和account_sub_type
    deliveryMethodList: [],
    billingCycleTypeList: [],
    acctDtoList: [], // 已存的账户组成的列表
    custAddrList: [],
    acctDetail: {},
    poaDefaultFileList: [],
    accountInfo: {},
  },
  effects: {
    *createAccount({ payload }, { call, put }) {
      const response = yield call(createAccount, payload);
      const { accountCode, acctId } = getRequestData(response);
      if (acctId) {
        message.success(i18n('BUSINESS_CREATE_ACCOUNT_SUCCESSFULLY'));
      }
      yield put({
        type: 'save',
        payload: { accountCode, acctId },
      });
      return acctId;
    },
    * clear(_, { select, put }) {
      const obj = yield select(state => state.billingAccountInfo);
      yield put({
        type: 'save',
        payload: { ...emptyObj(obj) },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
